<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader>
						Gestion des points de retrait

						<div class="card-header-actions">
							<CButton color="primary" @click="showAddModal">+ Ajouter</CButton>
						</div>
					</CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							remote-url="/api/pick_up_points"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #actions="{ item }">
								<td class="text-center">
									<a
										class="text-center icon-space"
										href="#"
										@click.prevent="showEditModal(item)">
										<CIcon name="cil-pencil"></CIcon>
									</a>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>

		<pickup-points-add ref="addModal" v-on:refresh="refresh" />
		<pickup-points-edit ref="editModal" v-on:refresh="refresh" />
	</div>
</template>

<script>
	import GDataTableRemote from '@/components/ghostlexly-components/GDataTableRemote';
	import PickupPointsAdd from '@/views/pages/pick-up-points/pickup-points-add';
	import PickupPointsEdit from '@/views/pages/pick-up-points/pickup-points-edit';
	export default {
		name: 'pickup-points-list',
		components: { PickupPointsEdit, PickupPointsAdd, GDataTableRemote },

		data() {
			return {
				fields: [
					{ key: 'id', label: '#' },
					{ key: 'name', label: 'Désignation' },
					{ key: 'actions', label: 'Actions', filter: false },
				],
			};
		},

		methods: {
			refresh() {
				this.$refs.mainTable.refresh();
			},

			showAddModal() {
				this.$refs.addModal.showModal = true;
			},

			async showEditModal(item) {
				const currentDate = new Date();
				this.$refs.editModal.timestamp = currentDate.getTime();
				await this.$nextTick();

				this.$refs.editModal.item = item;
				this.$refs.editModal.showModal = true;
			},
		},
	};
</script>
